import { render, staticRenderFns } from "./BenefitsKpiBar.vue?vue&type=template&id=38748712&scoped=true"
import script from "./BenefitsKpiBar.vue?vue&type=script&lang=js"
export * from "./BenefitsKpiBar.vue?vue&type=script&lang=js"
import style0 from "./BenefitsKpiBar.vue?vue&type=style&index=0&id=38748712&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38748712",
  null
  
)

export default component.exports